const htmlFontSize = 16;

const pixelsToRem = (pixels: number): string => {
  return `${pixels / htmlFontSize}rem`;
};

const createHeadingStyle = (
  fontSize: number,
  lineHeight: number,
  letterSpacing: string,
  fontWeight: number = 500,
) => ({
  fontWeight,
  fontSize: pixelsToRem(fontSize),
  lineHeight: pixelsToRem(lineHeight),
  letterSpacing,
});

const typography = {
  fontFamily:
    '"Roboto", Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  h1: createHeadingStyle(32, 40, '-0.01em'),
  h2: createHeadingStyle(24, 32, '-0.02em'),
  h2_5: createHeadingStyle(20, 28, '-0.02em'),
  h3: createHeadingStyle(16, 24, '-0.02em'),
  h4: createHeadingStyle(14, 24, '-0.02em'),
  h5: createHeadingStyle(12, 16, '-0.02em'),
  h6: createHeadingStyle(10, 14, '-0.01em'),
  xs: pixelsToRem(12),
  sm: pixelsToRem(14),
  md: pixelsToRem(16),
  lg: pixelsToRem(18),
  xl: pixelsToRem(20),
  '2xl': pixelsToRem(24),
  '3xl': pixelsToRem(30),
  '4xl': pixelsToRem(36),
  '5xl': pixelsToRem(48),
  '6xl': pixelsToRem(60),
  '7xl': pixelsToRem(72),
  '8xl': pixelsToRem(96),
  '9xl': pixelsToRem(128),
  legend: createHeadingStyle(16, 20, '0.25px', 500),
};

export default typography;
